import z from 'zod';

/** Initial write from client when creating a new user document. */
export const userWriteSchema = z.object({
  name: z.string().optional(),
  email: z.string().optional(),
  photoUrl: z.string().optional(),
});

export type UserWrite = z.infer<typeof userWriteSchema>;
